<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de inconsistência">
            <rkm-layout-content>
                <Form
                    @busy="busy = $event"
                    @items="items = $event"
                    @registro-codigo="registroCodigo = $event"
                    @model="getModel"
                />
            </rkm-layout-content>

            <rkm-layout-content v-if="registroCodigo">
                <List
                    :busy="busy"
                    :items="items"
                    :registro-codigo="registroCodigo"
                    :model="model"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/bpa/relatorio-inconsistencia/Form'
import List from '@/components/bpa/relatorio-inconsistencia/List'

export default {
    components: {
        Form,
        List,
    },
    data: () => ({
        busy: false,
        items: [],
        registroCodigo: null,
        model: null,
    }),
    methods: {
        getModel(model) {
            this.model = model
        }
    }
}
</script>